import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';

import { Button } from '@common/components/Button';
import { Title1 } from '@common/components/Typography';

export const Form = styled.form`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const WrappedTitle4 = styled(Title1)`
  margin-top: 0px;
`;

export const ErrorWrapper = styled.div`
  padding-top: 10px;
`;

export const AddressFormWrapper = styled.div<{ isVisible: boolean }>`
  opacity: 0;
  max-height: 0;
  transition: max-height 0.5s ease, opacity 0.5s ease;
  transition-delay: 0.25s;
  overflow: hidden;

  ${({ isVisible }) =>
    isVisible &&
    css`
      max-height: 1000vh;
      opacity: 1;
      overflow: visible;
    `};
`;

export const FormWrapper = styled.div`
  padding: 28px 0;

  ${({ theme }) => css`
    & + & {
      border-top: 1px solid ${theme.defaultColors.lightGrey};
    }

    ${media.md`
      padding: 28px 30px 30px 30px;
      border: 1px solid ${theme.defaultColors.lightGrey};

      & + & {
        margin-top: 20px;
      }
    `};
  `}
`;

export const ContinueButton = styled(Button)`
  margin: 30px 0 40px;
`;

export const DeliveryDescription = styled.div`
  margin-left: 30px;
`;
